import React, { useContext } from "react";

import { WidgetLocation } from "@data-types/live-widget/WidgetLocation";
import { EventContext } from "@gp/components";
import { LiveStatus, LiveStreamStatus } from "@gp/models";
import { useLiveWidgetStore } from "@state/hooks/live-widgets";
import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { analyticsTracker } from "@utils/analytics";
import classNames from "classnames";
import { observer } from "mobx-react-lite";

export default observer(function LiveStreamButton({
	store,
}: {
	store: EventViewStore;
}) {
	const event = useContext(EventContext);

	const teamOne = store.lookupsStore.teams.get(event.teamOneId || "");
	const teamTwo = store.lookupsStore.teams.get(event.teamTwoId || "");

	const tournament = store.lookupsStore.tournaments.get(
		event?.tournamentId || ""
	);

	const sport = store.lookupsStore.sports.get(event?.sportId || "");

	const { toggleLsWidget, findActiveLiveStreamWidget, eventsWithLsError } =
		useLiveWidgetStore();

	const isActive = findActiveLiveStreamWidget(
		event.id,
		WidgetLocation.EVENT_OFFER
	);

	const isUpcoming = event?.liveStreamStatus === LiveStreamStatus.Upcoming;
	const isFinished = event?.liveStreamStatus === LiveStreamStatus.Finished;

	const isDisabled =
		event?.liveStreamStatus == null ||
		isUpcoming ||
		isFinished ||
		eventsWithLsError.has(event.id);

	const buttonClasses = classNames(
		"at-actionLiveStream event__top__btn btn btn--square btn--square--sml btn--ghost btn--icon",
		{
			"is-disabled": isDisabled,
		}
	);

	const iconClasses = classNames("u-icon u-icon--sml", {
		"u-icon--action--stream--active": !isActive && !isDisabled,
		"u-icon--action--stream--selected": isActive && !isDisabled,
		"u-icon--action--stream--disabled": isDisabled,
		"u-icon--action--stream--cancelled": isFinished,
		"u-icon--action--stream--upcoming": isUpcoming,
	});

	if (isDisabled) {
		return null;
	}

	return (
		<button
			className={buttonClasses}
			type="button"
			onClick={() => {
				if (!isActive) {
					analyticsTracker.trackLiveStreamingViewed(
						event?.id || "",
						teamOne?.abrv || "",
						teamTwo?.abrv || "",
						tournament?.name || "",
						sport?.abrv || ""
					);
				}
				toggleLsWidget({
					eventId: event.id,
					teamOneName: teamOne?.name || "",
					teamTwoName: teamTwo?.name || "",
					location: WidgetLocation.EVENT_OFFER,
					isUserInitiated: true,
					autoPlay: true,
				});
			}}
			disabled={isDisabled}
		>
			<i className={iconClasses} />
		</button>
	);
});
